import React from 'react';
import { View, Text, Link } from '@react-pdf/renderer';
import { pdfStyles } from '../PDFStyles';

interface FooterSectionProps {
  pageNumber: number;
}

export const FooterSection: React.FC<FooterSectionProps> = ({ pageNumber }) => {
  return (
    <View style={pdfStyles.footer}>
      <View style={pdfStyles.footerMain}>
        <Text style={pdfStyles.footerText}>Powered by WaveScoop</Text>
        <Text style={pdfStyles.footerCenter}>Page {pageNumber}</Text>
        <Link src="https://wavescoop.com" style={pdfStyles.footerLink}>
          wavescoop.com
        </Link>
      </View>
      <Text style={pdfStyles.aiDisclaimer}>
        This analysis is powered by AI and should be used as a guide. Always consult with a professional before making decisions based on this analysis.
      </Text>
    </View>
  );
};